<template>
  <div id="ProjectMore">
    <div class="search-bar">
      <div class="search-box">
        <van-icon class="search-icon iconfont" class-prefix="icon" name="sousuo"></van-icon>
        <form action="javascript:void(0)"><input type="search" v-model="keyword" placeholder="请输入关键字" @keydown="searchHandle"/></form>
      </div>
    </div>
    <div class="project-tabs" v-if="!emptyShow">
      <van-tabs v-model="active" animated title-active-color="var(--main-color)" color="var(--main-color)">
        <van-tab v-for="(special, i) in data" :title="special.typeName" :key="i">
          <van-row>
            <van-col span="12" v-for="(item, index) in special.specialList" :key="index">
              <div class="project-card" @click="gotoDetails(item.id)">
                <p>{{ item.speciaName }}</p>
                <p>{{ item.speciaSub }}</p>
                <div class="icon-box">
                  <img
                      class="icon-img"
                      onload="SVGInject(this)"
                      round
                      fit="cover"
                      :src="complete(item.speciaIcon)"
                  />
                </div>
              </div>
            </van-col>
          </van-row>
        </van-tab>
      </van-tabs>
      <van-loading class="loading" type="spinner" color="#1989fa" v-if="loading"/>
    </div>
    <Error :type="'empty'" v-else></Error>
  </div>
</template>
<script>
import {complete, baseURL} from "@/utils/url"
import { querySpeciaMore } from '@/api/home'
import store from "@/store";
import {Toast} from "vant";
  export default {
    name: 'ProjectMore',
    data() {
      return {
        baseURL: baseURL,
        keyword: '',
        active: 0,
        serviceTypes: [],
        loading: false,
        serviceList: [],
        data:[],
        emptyShow: false
      }
    },
    created() {
      let self = this;
      self.loading = true;
      self.init()
    },
    methods: {
      complete,
      init() {
        this.emptyShow = false;
        querySpeciaMore({search: this.keyword}).then(resp=>{
          if(resp.code && resp.code != 200){
            Toast(resp.message);
            return false;
          }
          this.data = resp.data;
          if (this.data.length > 0) {
            this.emptyShow = false;
          } else {
            this.emptyShow = true;
          }
        }).finally(()=>{
          this.loading = false;
        })
      },
      searchHandle(e) {
        if(e.code == 'Enter' || e.keyCode == '13') {
          this.init()
        }
      },
      gotoDetails(id){
        this.$router.push("/project/details/"+id);
      }
    }
  }
</script>
<style scoped lang="scss">
  @import "../../assets/css/theme/theme";
  #ProjectMore{
    padding-top: 86px;
  }
  .search-bar {
    width: 100%;
    height: 44px;
    padding: 8px 15px;
    box-sizing: border-box;
    display: -webkit-flex;/* Safari */
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10001;
    background: #fff;
    color: $c333;
    .go-back{
      width: 28px;
      height: 28px;
      position: relative;
      .iconfont {
        position: absolute;
        left: 0;
        top: 4px;
        font-size: 20px;
        transform: rotate(180deg);
      }
    }
    .search-box {
      height: 28px;
      line-height: 28px;
      padding: 0 15px 0 35px;
      background: #F7F7F7;
      border: 1px solid #FFFFFF;
      border-radius: 14px;
      flex: 1;
      position: relative;
      @extend .font13;
      .search-icon{
        position: absolute;
        top:0;
        left: 15px;
      }
      form{
        width: 100%;
        background: transparent;
        height: 28px;
        line-height: 28px;
        padding: 0;
        input {
          float: left;
          width: 100%;
          height: 28px;
          line-height: 28px;
          background: transparent;
          @extend .font13;
          &::-webkit-search-cancel-button{
            -webkit-appearance: none;
          }
        }
      }
    }
    .assistant{
      height: 28px;
      line-height: 28px;
      margin-left: 15px;
      @extend .font16;
    }
  }
  .van-tabs__content {
    padding: 6px 9px;
  }
  .van-row{
    padding:10px;
  }
  .project-tabs {
    .project-card {
      position: relative;
      margin: 6px;
      padding: 10px;
      box-sizing: border-box;
      border-radius: 6px;
      background: #fff;
      p {
        position: relative;
        z-index: 999;
        padding-right: 52px;
      }
      p:nth-child(1) {
        margin-bottom: 5px;
        height: 24px;
        line-height: 24px;
        color: $c333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        @extend .font18;
      }
      p:nth-child(2) {
        height: 48px !important;
        line-height: 24px !important;
        color: $c999;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        @extend .font16;
      }
      .icon-box {
        position: absolute;
        right: 15px;
        top: 50%;
        z-index: 998;
        margin-top: -16px;
        img,
        svg {
          display: block;
          width: 32px;
          height: 32px;
          fill: var(--main-color);
        }
      }
    }
    .loading{
      position: fixed;
      left: 0;
      right: 0;
      top: 0px;
      bottom: 0;
      z-index: 999;
      background: rgba(0,0,0,.3);
      span{
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -20px;
        margin-top: -20px;
      }
    }
  }
  .empty{
    margin-top: 110px;
  }
</style>
